import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Disable noisy console logs in production, and in development unless DEBUG is truthy
const debugEnabled = typeof window !== 'undefined' && (window.localStorage?.DEBUG === 'true' || window.localStorage?.DEBUG === '1');
if (process.env.NODE_ENV === 'production' || !debugEnabled) {
  const noop = () => {};
  // Preserve error and warn; silence log/info/debug/trace
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.trace = noop;
  console.warn = noop;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the PWA service worker (enables "Install app" + offline support).
// Only in production builds so it never interferes with the dev server's HMR.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        // When a new version is found, activate it immediately.
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              installing.postMessage?.('SKIP_WAITING');
            }
          });
        });
      })
      .catch(() => {});
  });
}
